import React from 'react';
import Header from '../../components/header';
import HeaderBackButton from '../../components/header-back-button';
import { TextEditorMobileToolbar } from '../../components/styled-text-editor';
import { CommentPublishButton } from '../publish-button';

const CommentEditPageHeader = () =>
  <Header
    left={<HeaderBackButton/>}
    right={<CommentPublishButton text="comment-edit-page-header.update" formName="comment"/>}
    menu={<TextEditorMobileToolbar identifier="comment"/>}
  />;

export default CommentEditPageHeader;



// WEBPACK FOOTER //
// ./app/containers/comment-edit-page-header/comment-edit-page-header.js